import { render } from "./ScrollspyInview.vue?vue&type=template&id=0a210720"
import script from "./ScrollspyInview.vue?vue&type=script&lang=js"
export * from "./ScrollspyInview.vue?vue&type=script&lang=js"

import "./ScrollspyInview.vue?vue&type=style&index=0&id=0a210720&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__